// extracted by mini-css-extract-plugin
export default {"modal-content":"styles_modal-content__zvRRt","modal-content-description":"styles_modal-content-description__SlP1g"};